import { Box, SxProps, Theme } from "@mui/material";
import { ReactElement, ReactNode } from "react";

type FlexDirection = "row" | "row-reverse" | "column" | "column-reverse";

// inspired by https://www.radix-ui.com/themes/docs/components/flex
export const FlexBox = ({
  children,
  sx = {},
  className = "",
  flexDirection,
  direction,
  onClick,
  "data-testid": dataTestId,
  ...flex
}: {
  justifyContent?:
    | "space-between"
    | "space-around"
    | "space-evenly"
    | "flex-start"
    | "flex-end"
    | "center"
    | "stretch"
    | "end"
    | undefined;
  alignItems?:
    | "flex-start"
    | "flex-end"
    | "center"
    | "baseline"
    | "stretch"
    | undefined;
  flexDirection?: FlexDirection;
  direction?: FlexDirection;
  flexWrap?: "nowrap" | "wrap" | "wrap-reverse" | undefined;
  gap?: number | string | undefined;
  sx?: SxProps<Theme>;
  className?: string;
  children: ReactNode;
  "data-testid"?: string;
  onClick?: () => void;
}): ReactElement => {
  return (
    <Box
      className={className}
      onClick={onClick}
      data-testid={dataTestId}
      sx={{
        display: "flex",
        flexDirection: flexDirection || direction,
        ...flex,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
